import { Unity } from "./unity";
import { MaintenanceOrder } from "./maintenance-order";
import { MaintenanceLine } from "./maintenance-line";

export class Maintenance {
    id:number = 0;
    unity_id:number = 0;
    unity:Unity = new Unity(); 
    km:number = 0;
    hours:number = 0;
    maintenance_date:Date = new Date();
    description:string = '';
    type:string = 'Preventivo';
    maintenance_order_id:number = 0; 
    maintenance_order:MaintenanceOrder = new MaintenanceOrder();
    active:boolean = true;
    discount:number = 0;
    lines:MaintenanceLine[] = [];
    status:string = 'Creada'; 
    customer_id:number = 0;
    customer_name:string = '';
}
